var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission"},[_c('img',{attrs:{"src":require("@/assets/images/401.png"),"alt":"401，无权限"}}),_c('div',{staticClass:"permission-title"},[_vm._v("无访问权限")]),_c('div',{staticClass:"permission-desc"},[_vm._v(" 抱歉，您当前无法访问此页面可能是因为您尚未登录或者账户权限不足。 "),_c('a',{staticClass:"login-btn",on:{"click":_vm.jumpToPortal}},[_vm._v("请登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }